// --------------------------------------------------------------------------
// Heatmap Legend of CPT page
// --------------------------------------------------------------------------
import React from 'react';
import { Box, Flex} from '@chakra-ui/react';
import colormap from 'colormap';

const HeatmapCircleCPT: React.FC = () => {
  const cmap = colormap({
    colormap: 'bone',
    nshades: 256,
    format: 'rgba',
    alpha: 1
  });

  // Create a CSS gradient string from the colormap
  const gradient = `linear-gradient(to right, ${cmap
    .map(color => `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${color[3]})`)
    .join(', ')})`;

  return (
    <Flex  width="16px" height="16px"
      justify="center" align="center">
      <Box
        width={"13.3px"}
        height={'13.3px'}
        borderRadius="50%" // Make it circular
        background={gradient}
        border={'none'}
      />
    </Flex>
  );
};

export default HeatmapCircleCPT;